class LazyVideo extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    // Check if mobile device
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    
    var lazyVideoObserver = new IntersectionObserver(function (
      entries,
      observer,
    ) {
      entries.forEach(function (video) {
        if (video.isIntersecting) {
          for (var source in video.target.querySelectorAll('source')) {
            var videoSource = video.target.querySelectorAll('source')[source];
            if (
              typeof videoSource.tagName === 'string' &&
              videoSource.tagName === 'SOURCE'
            ) {
              videoSource.src = videoSource.dataset.src;
            }
          }

          var videoElement = video.target.querySelector('video');
          var videoFallback = video.target.querySelector(
            '.lazy-video-fallback',
          );

          // Ensure video is muted for mobile autoplay
          if (isMobile) {
            videoElement.muted = true;
            videoElement.setAttribute('muted', '');
            videoElement.setAttribute('playsinline', '');
          }

          videoElement.load();

          //detect low power mode and show fallback image
          videoElement.play().catch((error) => {
            // Handle various autoplay restrictions on mobile devices
            if (error.name === 'NotAllowedError' || error.name === 'NotSupportedError') {
              // Try playing muted video first
              videoElement.muted = true;
              videoElement.play().catch(() => {
                // If even muted video fails, show fallback with click-to-play
                videoElement.style.display = 'none';
                if (videoFallback) {
                  videoFallback.style.display = 'block';
                  videoFallback.style.cursor = 'pointer';
                  
                  // Add click handler to attempt playing video
                  videoFallback.addEventListener('click', function() {
                    videoElement.style.display = 'block';
                    videoFallback.style.display = 'none';
                    videoElement.muted = true;
                    videoElement.play().catch(() => {
                      // If still can't play, keep showing fallback
                      videoElement.style.display = 'none';
                      videoFallback.style.display = 'block';
                    });
                  });
                }
              });
            }
          });

          lazyVideoObserver.unobserve(video.target);
        }
      });
    });

    lazyVideoObserver.observe(this);
  }
}

customElements.define('lazy-video', LazyVideo);
